import {
  shorthands,
  makeStyles,
  mergeClasses,
  useButtonStyles_unstable,
} from "@fluentui/react-components";
import {
  useCommonRibbonButtonStyles,
  getRibbonButtonSizedStyles,
} from "../../next/commonRibbonButtonStyles.styles";
import type { RibbonButtonState } from "../../RibbonButton/next";
import { isNextStyleEnabled } from "@1js/acui-theme";

const useSplitButtonPrimaryButtonRootStyles = makeStyles({
  base: {
    paddingTop: "1px",
    paddingLeft: "9px",
    paddingRight: "2px",
    paddingBottom: "0px",
    ...shorthands.borderRight("0px"),
    minWidth: "20px",
  },
  small: {
    paddingLeft: "1px",
    borderRightWidth: "0px",
  },
  large: {
    height: "36px",
    minHeight: "36px",
    minWidth: "40px",
    ...shorthands.padding("0px"),
    borderBottomWidth: "0px",
    borderRightWidth: "1px",
    width: "100%",
  },
});

const useSplitButtonPrimaryButtonIconStyles = makeStyles({
  base: {
    marginTop: "0px",
  },
  large: {
    paddingTop: "2px",
  },
});

const useSplitButtonPrimaryButtonRootStylesNext = makeStyles({
  base: {
    ...shorthands.borderRight("0px"),
    ":focus": {
      borderRightWidth: "0px",
    },
  },
  small: {
    minWidth: "22px !important",
    paddingLeft: "2px !important",
    paddingRight: "2px !important",
    borderRightWidth: "1px !important",
  },
  medium: {
    minWidth: "28px",
    paddingRight: "2px",
  },
  large: {
    ...shorthands.borderRight("1px"),
    ...shorthands.borderBottom("0px"),
    height: "36px",
  },
});

const useSplitButtonPrimaryButtonIconStylesNext = makeStyles({
  large: {
    paddingBottom: "0px",
  },
});

export const useRibbonSplitButtonPrimaryButtonCustomStyles = (
  state: RibbonButtonState
) => {
  const rootStyles = useSplitButtonPrimaryButtonRootStyles();
  const iconStyles = useSplitButtonPrimaryButtonIconStyles();
  const rootStylesNext = useSplitButtonPrimaryButtonRootStylesNext();
  const iconStylesNext = useSplitButtonPrimaryButtonIconStylesNext();

  if (isNextStyleEnabled()) {
    state.root.className = mergeClasses(
      rootStylesNext.base,
      getRibbonButtonSizedStyles(state.size, rootStylesNext),
      state.root.className
    );
    if (state.icon) {
      state.icon.className = mergeClasses(
        getRibbonButtonSizedStyles(state.size, iconStylesNext),
        state.icon.className
      );
    }
  } else {
    state.root.className = mergeClasses(
      rootStyles.base,
      getRibbonButtonSizedStyles(state.size, rootStyles),
      state.root.className
    );

    if (state.icon) {
      state.icon.className = mergeClasses(
        iconStyles.base,
        getRibbonButtonSizedStyles(state.size, iconStyles),
        state.icon.className
      );
    }
  }
};

export const useRibbonSplitButtonPrimaryButtonStyles = (
  state: RibbonButtonState
) => {
  useRibbonSplitButtonPrimaryButtonCustomStyles(state);

  useCommonRibbonButtonStyles(state as RibbonButtonState);

  useButtonStyles_unstable(state);

  return state;
};
